import React from 'react'
import AALSnippet from './annotation/AALSnippet'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { AnnotationDataBoundingBox } from '../types/models/annotation'
import { setSelectedBoundingBox, selectEditedBBoxIndexes } from '../store/slices/annotationSlice'

interface SnippetWithOverlayProps {
  contentId: string
  bbox: AnnotationDataBoundingBox
  isSelected: boolean
  projectAnnotationType: string
  rotateLongSideVertical?: boolean
}

const SnippetWithOverlay: React.FC<SnippetWithOverlayProps> = ({
  contentId,
  bbox,
  isSelected,
  projectAnnotationType,
  rotateLongSideVertical = false,
}) => {
  const dispatch = useAppDispatch()
  const editedBBoxIndexes = useAppSelector(selectEditedBBoxIndexes)
  const isEdited = bbox.class_index !== undefined && editedBBoxIndexes.includes(bbox.class_index)

  const handleClick = () => {
    dispatch(setSelectedBoundingBox(bbox))
  }

  // Determine border style - use subtle border for all snippets
  const getBorderStyle = () => {
    // Use a consistent subtle border for all snippets (no purple selection border)
    return '1px solid #333'
  }

  return (
    <div className="position-relative ratio ratio-1x1">
      {(projectAnnotationType === 'bounding_box' ||
        projectAnnotationType === 'oriented_bounding_box') && (
        <div className="position-absolute top-0 start-0 w-100 h-100" onClick={handleClick}>
          <AALSnippet
            contentId={contentId}
            bbox={bbox}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              cursor: 'pointer',
              border: getBorderStyle(),
              backgroundColor: 'transparent',
            }}
            rotateLongSideVertical={rotateLongSideVertical}
            paddingMultiplier={1.8}
          />
        </div>
      )}
    </div>
  )
}

export default SnippetWithOverlay
